An optional free-text billing reference.

This appears on the invoice when SEEK bills the hirer for the job ad.
